export const firebaseConfig = {
    apiKey: "AIzaSyAdNPSiZ2lGJqRBcMp3aV21ATUKIrHtSpM",
    authDomain: "neat-beaker-279912.firebaseapp.com",
    databaseURL: "https://neat-beaker-279912.firebaseio.com",
    projectId: "neat-beaker-279912",
    storageBucket: "neat-beaker-279912.appspot.com",
    messagingSenderId: "658468726476",
    appId: "1:658468726476:web:670bc1d1ad3c9c20f64469",
    measurementId: "G-XSP139CP4P"
  };